var _line, _line2, _line3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinesInEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 2,
    viewBox: "0 0 99 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: 1.25,
    x2: 56.25,
    y2: 1.25,
    stroke: "url(#paint0_angular_2387_44947)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 64.75,
    y1: 1.25,
    x2: 77.25,
    y2: 1.25,
    stroke: "url(#paint1_angular_2387_44947)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 85.75,
    y1: 1.25,
    x2: 98.25,
    y2: 1.25,
    stroke: "url(#paint2_angular_2387_44947)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_2387_44947",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.5 2.5) rotate(90) scale(0.5 28.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#FFF1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#AE8625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#FFF1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#AE8625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9B373"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_2387_44947",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(71 2.5) rotate(90) scale(0.5 7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#FFF1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#AE8625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#FFF1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#AE8625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9B373"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_2387_44947",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(92 2.5) rotate(90) scale(0.5 7)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.166667,
    stopColor: "#FFF1D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.395833,
    stopColor: "#AE8625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#FFF1D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#AE8625"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9B373"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinesInEnd);
export default __webpack_public_path__ + "static/media/lines-in-end.5233faf96662f9c4db6ba2c157491e46.svg";
export { ForwardRef as ReactComponent };